<template>
  <div class="practice-dialog" @mousewheel="mousewheel" v-if="dialogShow">
    <div class="dialog-inner">
      <img
        class="close-img"
        src="../../assets/img/icon/close.png"
        alt=""
        @click="closeDialog"
      />
      <div v-loading="loading" v-if="info.finishCount == 0">
        <div class="dia-title">{{ info.name }}</div>
        <div class="dia-item">
          本套试卷共<span class="col">{{ subjectCount }}</span> 道题，共
          <span class="col">{{ mockInfo.typeSubjects.length }}</span> 个题型
          <span class="advice" v-if="mockInfo.duration"
            >建议答题时间：{{ $Tools.downTime(info.duration) }}小时</span
          >
        </div>
        <div class="dia-tip">
          注：练习部分（历年真题，模拟考试以及公开课练习）主观题暂不支持作答；用户切换至主观题时就表明用户已作答，系统将自动保存答题记录。
        </div>
        <div class="dia-list">
          <div
            class="list-item"
            v-for="(item, index) in mockInfo.typeSubjects"
            :key="index"
          >
            <div class="item-name">{{ item.contentType }}</div>
            <div class="item-count">
              共<span class="count">{{ item.subjects.length }}</span
              >道题
            </div>
          </div>
        </div>
      </div>
      <template v-else>
        <div class="dia-title">{{ info.name }}</div>
        <div class="dia-aleady">
          上次已练习了{{ info.finishCount }}题，是否继续？
        </div>
      </template>
      <div class="dia-btns">
        <div class="btn" @click="closeDialog">取消</div>
        <template v-if="info.finishCount == 0">
          <div class="btn btn2" @click="handleSubmit(1)">立即答题</div>
        </template>
        <template v-else>
          <div class="btn btn1" @click="handleSubmit(100)">重新开始</div>
          <div class="btn btn2" @click="handleSubmit(1)">继续练习</div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogShow: false,
      loading: false,
      paperType: "",
      mockInfo: {
        typeSubjects: [],
      },
    };
  },
  mounted() {},
  computed: {
    subjectCount() {
      let count = 0;
      this.mockInfo.typeSubjects.forEach((item) => {
        count += item.subjects.length;
      });
      return count;
    },
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },

    count: {
      type: Number,
    },
  },
  methods: {
    openDialog(paperType, paperId) {
      this.paperType = paperType;
      this.dialogShow = true;
      this.loading = true;
      this.$api.cms.resource.subject_detailsByPaperForClient
        .get({
          paperId,
          paperType,
          type: "测试",
        })
        .then((res) => {
          this.loading = false;
          this.mockInfo = res.data;
        });
    },
    closeDialog() {
      this.dialogShow = false;
    },
    handleSubmit(a) {
      this.dialogShow = false;
      this.$emit("submit", this.paperType, a);
    },
    mousewheel(e) {
      e.preventDefault();
    },
  },
};
</script>
<style lang="less" scoped>
.practice-dialog {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 22;
  background-color: rgba(0, 0, 0, 0.6);
  .dialog-inner {
    position: relative;
    padding: 32px;
    width: 480px;
    // height: 292px;
    border-radius: 8px;
    opacity: 1;
    background: #fff;
    box-sizing: border-box;
    .close-img {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
    .dia-title {
      margin-bottom: 16px;
      font-weight: bold;
      font-size: 18px;
      line-height: 26px;
      color: #333333;
    }
    .dia-item {
      font-size: 16px;
      color: #333;
      .advice {
        font-size: 12px;
        color: #a8aab8;
      }
      .col {
        color: #3480ff;
      }
    }
    .dia-tip {
      padding-top: 8px;
      font-size: 10px;
      line-height: 16px;
      color: #a8aab8;
    }
    .dia-list {
      margin: 16px 0;
      display: flex;
      flex-wrap: wrap;
      .list-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 204px;
        height: 60px;
        background: #f6f9f8;
        .item-name {
          font-weight: bold;
          font-size: 14px;
          line-height: 14px;
          color: #333;
        }
        .item-count {
          padding-top: 8px;
          font-size: 12px;
          color: #333;
          .count {
            color: #3480ff;
          }
        }
      }
    }
    .dia-aleady {
      padding: 20px 0 40px 0;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }
    .dia-btns {
      display: flex;
      align-items: center;
      justify-content: right;
      .btn {
        margin-right: 8px;
        width: 88px;
        height: 32px;
        border-radius: 16px;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f2f2f2;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.9);
      }
      .btn:hover {
        opacity: 0.8;
      }
      .btn1 {
        border: 1px solid #00b861;
        background: #fff;
        color: #00b861;
      }
      .btn2 {
        background-color: #00b861;
        color: #fff;
      }
    }
  }
}
</style>
